export const healthReportTabs = [
  { to: "/weekly-report", label: "Weekly", exact: true },
  { to: "/monthly-report", label: "Monthly", exact: true },
  { to: "/health-report", label: "Shared", exact: true },
] as const;
